import React from "react";

export const GridRow = ({ renderRow, headings, item }) => {
  return <>{renderRow(headings, item)}</>;
};
